import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { LineChartComponent } from "@/types/insights";
import { useMemo } from "react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { ChartCard } from "./InsightsComponentCard";
import { buildChartConfig, buildLineChartData, formatNumber } from "./insights-component-utils";

export const InsightsLineChartCard = ({ component }: { component: LineChartComponent }) => {
  const data = useMemo(() => buildLineChartData(component), [component]);
  const config = useMemo(
    () => buildChartConfig(component.series.map(({ key, label }) => ({ key, label }))),
    [component]
  );

  if (data.length === 0) return null;

  return (
    <ChartCard title={component.title} description={component.description}>
      <ChartContainer config={config} className="h-72 w-full aspect-auto">
        <LineChart data={data} margin={{ left: 12, right: 12, top: 12 }}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="x" tickLine={false} axisLine={false} />
          <YAxis
            tickLine={false}
            axisLine={false}
            tickFormatter={(value: number) =>
              component.yAxis?.unit ? `${formatNumber(value)} ${component.yAxis.unit}` : formatNumber(value)
            }
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                formatter={(value) => (
                  <span className="font-mono tabular-nums">
                    {typeof value === "number" ? formatNumber(value) : String(value)}
                  </span>
                )}
              />
            }
          />
          <ChartLegend content={<ChartLegendContent />} />
          {component.series.map((series) => (
            <Line
              key={series.key}
              dataKey={series.key}
              name={series.label}
              type="monotone"
              stroke={`var(--color-${series.key})`}
              strokeWidth={2}
              dot={false}
            />
          ))}
        </LineChart>
      </ChartContainer>
    </ChartCard>
  );
};
